import { SalesLine } from '../storage/types'

export const hasMultiStores = (salesLines: SalesLine[] | undefined) => {
  const uniqueLocations = [...new Set(salesLines?.map((line) => line.inventoryLocationId))]
  return uniqueLocations.length > 1
}
